// extracted by mini-css-extract-plugin
export var actions = "_kh-d";
export var benefitCard = "_kh-a";
export var benefitIcon = "_kh-b";
export var benefitLabel = "_kh-c";
export var benefits = "_kh-9";
export var bodyText = "_kh-8";
export var closeButton = "_kh-2";
export var content = "_kh-3";
export var eyebrow = "_kh-4";
export var heading = "_kh-5";
export var image = "_kh-f";
export var imagePanel = "_kh-e";
export var modal = "_kh-0";
export var shell = "_kh-1";
export var title = "_kh-6";
export var titleOffer = "_kh-7";